var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rounded-8 border-1 border-black-900/0 bg-black-900/20 border-solid p-8"},[_c('IconClose',{attrs:{"fill":"white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }